import React, { Component } from 'react';

import "./Promo.scss"

import json from "../../api/data.json"
import playIcon from "../../assets/images/mobile/play.png"

class Promo extends Component {
  constructor() {
    super();
    this.state = {
      imageFull: {
        image: {
          backgroundImage: "url(" + (window.screen.width <= 768 ? json.promo.mobile_imageURL : json.promo.imageURL) + ")"
        },
        play: {
          backgroundImage: "url(" + playIcon + ")"
        }
      }
    }
  }
  render() {
    return (
      <section className="section section-promo">
      <div className="padding">
      <h3 dangerouslySetInnerHTML={{__html: json.promo.headline}}></h3>
      <h4 dangerouslySetInnerHTML={{__html: json.promo.desc}}></h4>
      </div>
      </section>
    );
  }
}

export default Promo;



// WEBPACK FOOTER //
// ./src/components/Promo/Promo.js